export const parseAttachmentDataJson = (dataJson: string | null | undefined): Record<string, unknown> | null => {
  if (!dataJson) {
    return null
  }

  try {
    const parsed: unknown = JSON.parse(dataJson)

    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
      return null
    }

    return parsed as Record<string, unknown>
  } catch {
    return null
  }
}
